import axios from 'axios';
import { IFormInputs } from '../pages/signUpPage/validation';

const getAuthHeaders = () => {
  try {
    const token = localStorage.getItem('jwtToken');
    // Server issues tokens already prefixed with "Bearer " (see controller.ts authenticate handler)
    return token ? { Authorization: token } : {};
  } catch {
    return {};
  }
};

export default {
  updateDashboard: (input: any) => {
    return axios.put('/api/updateDashboard', input);
  },
  // ------------------- hhahahahahaha
  spotlightWriteFunction: (input: any) => {
    return axios.put(`/api/updateSpotlight`, input);
  },
  spotlightReadFunction: () => {
    return axios.get(`/api/getSpotlight`);
  },
  getNonprofit: () => {
    return axios.get(`/api/getNonprofit`);
  },
  authenticate: (input: IFormInputs) => {
    return axios.post(`/api/authenticate`, input);
  },
  getProfile: (id: string) => {
    return axios.get(`/api/find/nonprofit/${id}`);
  },
  getNonProfitEvents: (id: string) => {
    return axios.get(`/api/find/nonprofit/events/${id}`);
  },
  getNpCampaigns: (id: string) => {
    return axios.get(`/api/getNpCampaigns/${id}`);
  },
  getNpOverview: (id: string) => {
    return axios.get(`/api/getNpOverview/${id}`);
  },
  //get User Profile
  getUserPhoneNumber: (id: string) => {
    return axios.get(`/api/find/user/phoneNumber/${id}`);
  },
  subscribe: (email: any) => {
    return axios.post('/api/subscribe', email);
  },
  forgot: (email: any) => {
    return axios.post('/api/forgot', email);
  },
  findNP: (term: string) => {
    return axios.get(`/api/find/nonprofit/${term}`);
  },
  check: (email: string | undefined) => {
    return axios.get(`/api/check/${email}`);
  },
  confirm: (id: string, type: string) => {
    return axios.get(`/api/confirm/${type}/${id}`);
  },
  findByEin: (ein: string | undefined) => {
    return axios.get(`/api/find/nonprofitExists/${ein}`);
  },
  approve: (id: string, type: string, pw: string) => {
    return axios.put(`/api/approve/${type}/${id}/${pw}`);
  },

  register: (input: IFormInputs, type: string) => {
    return axios.post(`/api/register/${type}`, input);
  },

  resendConfirmation: (email: any) => {
  return axios.post('/api/resendConfirmation', { email });
},

  registerNonprofitWithoutEin: (input: IFormInputs, type: string) => {
    return axios.post(`/api/registerNonprofitWithoutEin/${type}`, input);
  },

  saveWishlist: (input: any) => {
    return axios.post(`/api/saveWishlist`, input);
  },
  deleteWishlist: (input: any) => {
    return axios.post(`/api/deleteWishlist`, input);
  },
  saveMarketplace: (input: any) => {
    return axios.post(`/api/saveMarketplace`, input);
  },
  deleteMarketplace: (input: any) => {
    return axios.post(`/api/deleteMarketplace`, input);
  },
  updateNP: (input: any) => {
    return axios.put(`/api/updateNP`, input);
  },
  updateNPCampaigns: (input: any) => {
    return axios.put(`/api/updateNPCampaigns`, input);
  },
  updateNPEvents: (input: any) => {
    return axios.put(`/api/updateNPEvents`, input);
  },

  updateNPSocialMedias: (input: any) => {
    return axios.put(`/api/updateNPSocialMedias`, input);
  },
  searchNonProfit: (
    search_query: any,
    limit: number,
    curDisplayRec: number,
    showAll?: boolean
  ) => {
    return axios.get(`/api/search/nonprofit`, {
      params: {
        search_query: search_query,
        limit: limit,
        currentDisplayRecords: curDisplayRec,
        showAll: showAll
      }
    });
  },

  createStripeAccount: (input: any) => {
    return axios.post(`/api/createStripeAccount`, input);
  },
  getStripeAcct: (stripeID: string) => {
    console.log(stripeID);
    return axios.get(`/api/getStripeAcct/${stripeID}`);
  },
  getBankAcct: (stripeID: string) => {
    return axios.get(`/api/getBankAcct/${stripeID}`);
  },
  updateBankAcct: (stripeID: string, acct: string, upObj: object) => {
    return axios.put(`/api/updateBankAcct/${stripeID}/${acct}`, upObj);
  },
  removeBankAcct: (stripeID: string, acct: string) => {
    return axios.put(`/api/removeBankAcct/${stripeID}/${acct}`);
  },
  getStripeBalance: (id: string) => {
    return axios.get(`/api/getStripeBalance/${id}`);
  },
  getTransactions: (id: string) => {
    return axios.get(`/api/getTransactions/${id}`);
  },
  getDonationReports: (npID: string, query: string) => {
    return axios.get(`/api/getDonationReports/${npID}/${query}`);
  },
  getDonorDonations: (donorEmail: string, query: string) => {
    return axios.get(`/api/getDonorDonations/${donorEmail}/${query}`);
  },

  getAllDonorDonations: (donorEmail: string, query: string) => {
    return axios.get(`/api/getAllDonorDonations/${donorEmail}${query}`);
  },

  getAllDonorSubscriptions: (donorEmail: string, query: string) => {
    return axios.get(`/api/getAllDonorSubscriptions/${donorEmail}${query}`);
  },

  getDashboardStats: (donorEmail: string) => {
    return axios.get(`/api/getDashboardStats/${donorEmail}`);
  },

  createStripeAccountLinks: (input: any) => {
    return axios.post(`/api/createStripeAccountLinks`, input);
  },

  updateUserStripeInfo: (input: any) => {
    return axios.post(`/api/updateUserStripeInfo`, input);
  },

  emailDonorReport: (input: any) => {
    return axios.post('/api/emailDonorReport', input);
  },

  // getMonthlyTransactions: (npID: string) => {
  //   return axios.get(`/api/getMonthlyTransactions/${npID}`);
  // },

  createPaymentIntent: (input: any) => {
    return axios.post(`/api/createPaymentIntent`, input);
  },

  createPaymentIntentACH: (input: any) => {
    return axios.post(`/api/createPaymentIntentACH`, input);
  },

  createPaymentIntentGoogle: (input: any) => {
    return axios.post(`/api/createPaymentIntentGoogle`, input);
  },

  retrievePaymentIntent: (id: string, donationStripeAccount: any) => {
    return axios.get(`/api/retrievePaymentIntent/${id}/${donationStripeAccount}`);
  },

  createDonation: (input: {
    id: string;
    campaign: string;
    email: string;
    amount: number;
    optIn: Boolean;
    tip: number;
    type: string;
    status: string;
    stripeTrans?: string;
    merchantId?: string;
    token?: string;
    PayerID?: string;
    googlePayData?: any;
    applePayData?: any;
  }) => {
    return axios.post(`/api/createDonation`, input);
  },

  addNPEvent: (input: {
    orgID: any;
    eventType: string;
    post: string;
    eventImage: any;
    name: string;
    description: string;
    longDescription: string;
    eventDate: Date;
    timeStart: Date;
    timeEnd: Date;
    timezone: string;
    recurringEvent: Boolean;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipcode?: any;
    host: string;
    volunteerOpportunities: string;
    tickets: Array<any>;
  }) => {
    return axios.post(`/api/createEvent`, input);
  },

  getOneCampaign: (id: string) => {
    return axios.get(`/api/getOneCampaign/${id}`);
  },

  searchCampaign: (
    search_query: any,
    limit: number,
    curDisplayRec: number,
    showAll: boolean
  ) => {
    return axios.get(`/api/search/campaign`, {
      params: {
        search_query: search_query,
        limit: limit,
        currentDisplayRecords: curDisplayRec,
        showAll: showAll
      }
    });
  },
  deleteCampaign: (id: string, npID: string) => {
    axios.delete(`/api/campaign/delete/${npID}/${id}`);
  },
  archiveCampaign: (id: string, npID: string) => {
    return axios.put(`/api/campaign/archive/${npID}/${id}`);
  },
  unarchiveCampaign: (id: string, npID: string, slug?: string) => {
    return axios.put(`/api/campaign/unarchive/${npID}/${id}`, { slug });
  },
  getActiveCampaigns: () => {
    return axios.get('api/find/campaigns/active');
  },
  createDonorCampaign: (input: any) => {
    return axios.post(`/api/campaigns/donor-create`, input);
  },
  updateDonorCampaign: (campaignId: string, input: any) => {
    return axios.put(`/api/campaigns/donor-update/${campaignId}`, input);
  },
  deleteDonorCampaign: (campaignId: string, userID: string) => {
    return axios.delete(`/api/campaigns/donor-delete/${campaignId}`, { params: { userID } });
  },
  archiveDonorCampaign: (campaignId: string, userID: string) => {
    return axios.put(`/api/campaigns/donor-archive/${campaignId}`, { userID });
  },
  unarchiveDonorCampaign: (campaignId: string, userID: string, slug?: string) => {
    return axios.put(`/api/campaigns/donor-unarchive/${campaignId}`, { userID, slug });
  },
  contactOrganizer: (campaignId: string, input: { name: string; email: string; message: string }) => {
    return axios.post(`/api/campaigns/${campaignId}/contact-organizer`, input);
  },
  getMyCampaigns: (userID: string) => {
    return axios.get(`/api/campaigns/mine/${userID}`);
  },
  getMyFundraiserDonations: (userID: string, query: string) => {
    return axios.get(`/api/campaigns/mine/${userID}/donations?${query}`);
  },
  getEligibleNonprofits: (search?: string, skip = 0, limit = 20) => {
    return axios.get(`/api/nonprofits/eligible`, { params: { search, skip, limit } });
  },
  checkCampaignSlug: (slug: string, excludeId?: string) => {
    return axios.get(`/api/campaigns/check-slug`, { params: { slug, excludeId } });
  },
  getCampaignBySlug: (slug: string) => {
    return axios.get(`/api/campaigns/slug/${slug}`);
  },

  //authenticate token for resetting password
  authenticateResetPwToken: (token: string) => {
    return axios.get(`/api/authenticate/token`, {
      params: {
        resetPasswordToken: token
      }
    });
  },

  //update password
  updatePassword: (userId: string, pw: string) => {
    return axios.put(`/api/update/password`, {
      userId: userId,
      password: pw
    });
  },

  updateUser: (updateUser: any) => {
    return axios.put(`/api/update/user`, { updateUser });
  },

  deleteUser: (userId: string) => {
    return axios.delete(`/api/delete/user/${userId}`);
  },

  sendFeedback: (userName: string, email: string, description: string) => {
    return axios.get(`/api/sendFeedback`, {
      params: {
        userName: userName,
        email: email,
        description: description
      }
    });
  },

  matchingProgram: (
     name: string, 
    lastName: string, 
    companyOrOrganization: string,
    position: string,
    companyEmail: string,
    managerName: string,
    teamName: string,
    donationToMatch: string,
  ) => {
    return axios.get(`/api/matchingProgram`, {
      params: {
        name: name,
        lastName: lastName,
        companyOrOrganization: companyOrOrganization,
        position: position,
        companyEmail: companyEmail,
        managerName: managerName,
        teamName: teamName,
        donationToMatch: donationToMatch,
      }
    });
  },

  checkNickname: (nickname: string | undefined) => {
    return axios.get(`/api/checkNickname/${nickname}`);
  },

  updateNickname: (input: { npID: string; nickname: string }) => {
    return axios.put(`/api/updateNickname`, input);
  },

  checkGuideStar: (ein: string) => {
    return axios.get(`/api/checkGuidestar/${ein}`);
  },

  toggleLive: (npID: string) => {
    return axios.put('/api/toggleLive', { npID });
  },

  checkPassword: (userId: string, pw: string) => {
    return axios.get(`/api/check/password/${userId}/${pw}`);
  },

  fetchUserPreferences: (userId: string) => {
    return axios.get(`/api/fetch/userPreferences/${userId}`);
  },

  authenticateAdmin: (password: string) => {
    return axios.post(`/api/authenticateAdmin`, { password });
  },

  updateNPImpacts: (input: any) => {
    return axios.put(`/api/updateNPImpacts`, input);
  },

  getCalendarEvents: () => {
    return axios.get('api/find/events');
  },

  search: (
    search_query: any,
    limit: number,
    curDisplayRec: number,
    searchEngineCategory: string,
    showAll?: boolean
  ) => {
    return axios.get(`/api/search`, {
      params: {
        search_query: search_query,
        limit: limit,
        currentDisplayRecords: curDisplayRec,
        searchEngineCategory: searchEngineCategory,
        showAll: showAll
      }
    });
  },

  handleEventLikedButton: (
    eventId: string,
    userId: string,
    isLiked: boolean
  ) => {
    return axios.put(`/api/handleEventLikedButton`, {
      eventId,
      userId,
      isLiked
    });
  },

  getUserEvents: (userId: string) => {
    return axios.get(`/api/getUserEvents/${userId}`);
  },

  createUpdate: (newUpdateForm: {
    title: string;
    description: string;
    link: string;
  }) => {
    return axios.post(`/api/createUpdate`, newUpdateForm);
  },

  getUpdate: () => {
    return axios.get(`/api/getUpdate`);
  },

  deleteUpdate: (id: string) => {
    return axios.delete(`/api/deleteUpdate/${id}`);
  },

  updateUpdate: (update: {
    _id: string;
    title: string;
    description: string;
    link: string;
    createdAt: Date;
    upDatedAt: Date;
  }) => {
    console.log('&*&*&*&*&*&*&*&*&*&');
    return axios.put(`/api/updateUpdate`, update);
  },

  sendBusinessSignUpEmail: (info: {
    businessName: string;
    contactName: string;
    email: string;
  }) => {
    return axios.get(`/api/sendBusinessSignUpEmail`, {
      params: {
        businessName: info.businessName,
        email: info.email,
        contactName: info.contactName
      }
    });
  },

    sendNonprofitOrganizationDonationEmail: (info: {
    nonprofitEmail: any,
    name: any,
    email: any,
    date: any,
    type: any,
    amount: any,
    fundraise_name: any,
    nonprofit_name: any,
    payment_type: any,
    status: any,
  }) => {
    return axios.get(`/api/sendNonprofitOrganizationDonationEmail`, {
      params: {
        nonprofitEmail: info.nonprofitEmail,
        name: info.name,
        email: info.email,
        date: info.date,
        type: info.type,
        amount: info.amount,
        fundraise_name: info.fundraise_name,
        nonprofit_name: info.nonprofit_name,
        payment_type: info.payment_type,
        status: info.status,
      }
    });
  },

  sendNeddieOrganizationDonationEmail: (info: {
    date: string,
    nonprofit_name: any,
    amount: any,
    type: string,
    fees: any,
    status: any,
  }) => {
    return axios.get(`/api/sendNeddieOrganizationDonationEmail`, {
      params: {
        date: info.date,
        nonprofit_name: info.nonprofit_name,
        amount: info.amount,
        type: info.type,
        fees: info.fees,
        status: info.status
      }
    });
  },

  getEvent: (id: string, userId?: string) => {
    return axios.get(`/api/getEvent`, {
      params: {
        eventId: id,
        userId: userId === undefined ? 0 : userId
      }
    });
  },

  createPartnerReferral: (url: string , OrgId : string) => {
    return axios.get(`/api/createPartnerReferral?returnUrl=${encodeURIComponent(url)}&OrgId=${OrgId}`);
  },

  getPaypalPartnerDetail: (merchantIdInPayPal: any) => {
    return axios.get(`/api/getPaypalPartnerDetail?merchantIdInPayPal=${encodeURIComponent(merchantIdInPayPal)}`);
  },

  createPaypalOrder: (input: any) => {
    return axios.post(`/api/createPaypalOrder`, input);
  },

  capturePaypalOrder: (input: any) => {
    return axios.post(`/api/capturePaypalOrder`, input);
  },

  registerPaypalDomain: (input: any) => {
    return axios.post(`/api/registerPaypalDomain`, input);
  },

  // Recurring payment APIs
  createRecurringPayment: (input: any) => {
    return axios.post(`/api/createRecurringPayment`, input);
  },

  createRecurringPaymentACH: (input: any) => {
    return axios.post(`/api/createRecurringPaymentACH`, input);
  },

  createGoogleOrAppleSubscriptionIntent: (input: any) => {
    return axios.post(`/api/createGoogleOrAppleSubscriptionIntent`, input);
  },

  createRecurringPaymentGoogle: (input: any) => {
    return axios.post(`/api/createRecurringPaymentGoogle`, input);
  },

  createRecurringPaymentApple: (input: any) => {
    return axios.post(`/api/createRecurringPaymentApple`, input);
  },

  createSetupIntent: (input?: any) => {
    return axios.post(`/api/createSetupIntent`, input || {});
  },

  cancelRecurringPayment: (subscriptionId: string) => {
    return axios.post(`/api/cancelRecurringPayment`, { subscriptionId });
  },

  cancelRecurringPaymentImmediately: (subscriptionId: string) => {
    return axios.post(`/api/cancelRecurringPaymentImmediately`, { subscriptionId });
  },

  getSubscription: (subscriptionId: string) => {
    return axios.get(`/api/getSubscription/${subscriptionId}`);
  },

  updateRecurringPayment: (input: any) => {
    return axios.put(`/api/updateRecurringPayment`, input);
  },

  getCustomerSubscriptions: (email: string, nonProfitId: any) => {
    return axios.get(`/api/getCustomerSubscriptions/?email=${encodeURIComponent(email)}&nonProfitId=${nonProfitId}`);
  },

  createRecurringDonation: (input: any) => {
    return axios.post(`/api/createRecurringDonation`, input);
  },

  // Invoice APIs for recurring payments
  downloadLatestInvoice: (subscriptionId: string) => {
    return axios.get(`/api/downloadLatestInvoice/${subscriptionId}`);
  },

  getInvoiceDetails: (invoiceId: string, nonProfitId: any) => {
    //TOOD: pass non profit id
    return axios.get(`/api/getInvoiceDetails?invoiceId=${invoiceId}&nonProfitId=${nonProfitId}`);
  },

  getSubscriptionInvoices: (subscriptionId: string) => {
    return axios.get(`/api/getSubscriptionInvoices/${subscriptionId}`);
  },

  getNpRecurringDonations: (npID: string, query?: string) => {
    const url = query ? `/api/getNpRecurringDonations/${npID}?${query}` : `/api/getNpRecurringDonations/${npID}`;
    return axios.get(url);
  },

  // PayPal recurring payment APIs
  createPayPalRecurringPayment: (input: any) => {
    return axios.post(`/api/createPayPalRecurringPayment`, input);
  },

  cancelPayPalRecurringPayment: (subscriptionId: string) => {
    return axios.post(`/api/cancelPayPalRecurringPayment`, { subscriptionId });
  },

  getPayPalSubscription: (subscriptionId: string) => {
    return axios.get(`/api/getPayPalSubscription/${subscriptionId}`);
  },

  getCustomerPayPalSubscriptions: (email: string) => {
    return axios.get(`/api/getCustomerPayPalSubscriptions/${encodeURIComponent(email)}`);
  },

  createPayPalRecurringDonation: (input: any) => {
    return axios.post(`/api/createPayPalRecurringDonation`, input);
  },

  updatePayPalRecurringPayment: (input: any) => {
    return axios.put(`/api/updatePayPalRecurringPayment`, input);
  },

  cancelPayPalRecurringPaymentImmediately: (subscriptionId: string) => {
    return axios.post(`/api/cancelPayPalRecurringPaymentImmediately`, { subscriptionId });
  },

  getPayPalSubscriptionTransactions: (subscriptionId: string) => {
    return axios.get(`/api/getPayPalSubscriptionTransactions/${subscriptionId}`);
  },

  generatePayPalInvoicePDF: (subscriptionId: string) => {
    return axios.get(`/api/generatePayPalInvoicePDF/${subscriptionId}`, {
      responseType: 'blob' // Important for PDF download
    });
  },

  testPayPalConnection: () => {
    return axios.get(`/api/testPayPalConnection`);
  },

  getAllDonationsForNp: (npID: string, query?: string) => {
    const url = query ? `/api/getAllDonationsForNp/${npID}?${query}` : `/api/getAllDonationsForNp/${npID}`;
    return axios.get(url);
  },

  // Nonprofit API Integration
  getNonprofitInfo: (nonprofitId: string) => {
    return axios.get(`/api/nonprofit/${nonprofitId}/info`);
  },

  generatePublicProfileLink: (nonprofitId: string, params?: any) => {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    return axios.get(`/api/nonprofit/${nonprofitId}/profile-link${queryString}`);
  },

  generateIframeCode: (nonprofitId: string, params?: any) => {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    return axios.get(`/api/nonprofit/${nonprofitId}/iframe-code${queryString}`);
  },

  validateNonprofitApiAccess: (nonprofitId: string) => {
    return axios.get(`/api/nonprofit/${nonprofitId}/validate`);
  },

  searchNonprofits: (params: { name?: string; location?: string; category?: string }) => {
    return axios.get('/api/nonprofit/search', { params });
  },

  // Admin donation report
  fetchDonationReport: (startDate: any, endDate: any) => {
    return axios.get('/api/fetchDonationReport?startDate=' + startDate + '&endDate=' + endDate);
  },

  // File upload — sends file as multipart/form-data; optionally deletes oldFileUrl server-side
  uploadFile: (file: Blob, fileName: string, oldFileUrl?: string) => {
    const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB - must match server limit

    // Client-side file size validation
    if (file.size > MAX_FILE_SIZE_BYTES) {
      return Promise.reject(new Error(
        `File size (${(file.size / 1024 / 1024).toFixed(2)} MB) exceeds maximum allowed size of ${MAX_FILE_SIZE_BYTES / 1024 / 1024} MB`
      ));
    }

    const formData = new FormData();
    formData.append('file', file, fileName);

    if (oldFileUrl) {
      formData.append('oldFileUrl', oldFileUrl);
    }

    return axios.post('/api/files/upload', formData, {
      headers: getAuthHeaders(),
    });
  },

  // File delete by public URL
  deleteFile: (fileUrl: string) => {
    return axios.delete('/api/files/file', {
      data: { fileUrl },
      headers: getAuthHeaders(),
    });
  },

};
